const GridElementItemButtonModel = {
  target: '',
  cssClasses: '',
  icon: '',
  url: { pl: '', en: '' },
  label: { pl: '', en: '' },
};

export default GridElementItemButtonModel;
